import React from 'react';
import ReactDOM from 'react-dom';
import './MainBody.css'
import Logo_LIG from './Images/Logo-LIG.jpg'
import SE from './Images/SE.png'

class WorkExp extends React.Component {
  render (){
    return (
      <div id="work" class="container-fluid bg-3 text-center">
        <h3>WORK EXPERIENCE </h3><br /><br />
        <div class="row">
          <div class="col-sm-6">
          <img src={Logo_LIG} height="100px" width="100px" class="getdown"/><br />
          <b>Laboratoire d'Informatique de Grenoble</b><br />
          <a href="https://www.liglab.fr/en" target="blank">Grenoble Informatics Laboratory</a>
          </div>
          <div class="col-sm-6">
            <h3>Ipanema</h3>
            Ipanema is a domain-specific language to define schedulers of processes, and the characteristics for process scheduling on a multi-core system.<br />
            Ipanema is based on Bossa, a language allowing to write safeuser-defined scheduling policies on single core systems.<br />
            Three main tasks :<br />
            <br /><b>Cload field handling of a Core</b><br />
              <b>Ensure that all the Process declaration are initialized</b> <br />
              <b>Moving initialization of the process</b> <br />
            <br /><br />
            <p>For more information please see my paper :) <a href="https://salmanpersonal.000webhostapp.com/Internship.pdf" target="blank">click here</a></p>
          </div>
        </div>
        <hr/>
        <div class="row">
          <div class="col-sm-6">
          <img src={SE} height="100px" width="100px" class="getdown"/><br />
          <b>SE Factory</b><br />
          <a href="https://sefactory.io/" target="blank">Full Stack Web Trainee</a>
          </div>
          <div class="col-sm-6 topmar">
            <h3>SE Factory Web Developer </h3>
            <br />SE Factory is an intensive full-stack web development Bootcamp that has been running since February 2016 in Beirut, Lebanon.<br />
          </div>
        </div>
      </div>
    )
  }
}

export default WorkExp;
